export default __webpack_public_path__ + "init.mp3";